// extracted by mini-css-extract-plugin
module.exports = {"footer":"Reviews_footer__2FjoK","header":"Reviews_header__x9CJ5","review":"Reviews_review__cSjKg","photo":"Reviews_photo__QnQei","content":"Reviews_content__1m9Pq"};